import type { CoreTypes } from '../../../../core';
import type { Types } from '../../../types';

export function parseMinimumBreakLength (value: CoreTypes.breakLength | null | undefined): Types.Shared.EventBreakDuration | undefined {
  if (value == null) return;

  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value;

  if (Array.isArray(value)) {
    if (value.length !== 2) throw new Error('(RS::To::parseMinimumBreakLength) BreakLength array must have exactly two elements');
    const [bef, aft] = value;
    return { bef, aft };
  }

  throw new Error('(RS::To::parseMinimumBreakLength) BreakLength is neither boolean, number or number array');
};
